module.exports = __webpack_public_path__ + "img/royyak_logo.e16af477.png";